import React, {useState} from "react";
import { cdata } from "./api";
import SDInput from "./tools/sdInput";
import SDBtn from "./tools/sdBtn";
import SDSwitch from "./tools/sdSwitch";
import SDcalendar from "./tools/sdcalendar";
import SDJourney from "./tools/sdJourney";
import SDCheck from "./tools/sdCheck";
import SDRadio from "./tools/sdRadio";
import SDAccordion from "./tools/sdAccordion";
import SDDropdown from "./tools/sdDropdown";
import './demo.scss';
import SDRadioGroup from "./tools/sdRadioGroup";

function Demo (props) {
    let nowDate = new Date();
    const [selectMemo, setSelectMemo] = useState({
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        day: new Date().getDate(),
        date: new Date(),
        selected: false,
        memo: [{
            index: 2,
            startYear: 2022,
            startMonth: 8,
            startDay: 5,
            startHour: 10,
            startDate: new Date(2022,8,5),
            endYear: 2022,
            endMonth: 8,
            endDay: 5,
            endHour: 12,
            endDate: new Date(2022,8,5),
            title: "aaa",
            type: "aaa",
            color: "#aaffff",
        }]
    });
    
    function aaa (a) {
    }

    function click() {
    }

    function selectDay(d) {
        setSelectMemo(d)
    }

    let cMemo = [{
        index: 2,
        startYear: 2022,
        startMonth: 8,
        startDay: 5,
        startHour: 10,
        startDate: new Date(2022,8,5),
        endYear: 2022,
        endMonth: 8,
        endDay: 8,
        endHour: 12,
        endDate: new Date(2022,8,8),
        title: "事件1",
        type: "aaa",
        color: "#E1A679",
    },
    {
        index: 1,
        startYear: 2022,
        startMonth: 8,
        startDay: 5,
        startHour: 15,
        startDate: new Date(2022,8,5),
        endYear: 2022,
        endMonth: 8,
        endDay: 5,
        endHour: 18,
        endDate: new Date(2022,8,5),
        title: "事件2",
        type: "bbb",
        color: "#B1B479",
    }];

    let topic = '測試用標題';
    let content = '你好晚安 這是測試內文'
    let testArray = [
        {
            key: 'aaa',
            value: 'aaa',
        },
        {
            key: 'aab',
            value: 'aab',
        },
        {
            key: 'aac',
            value: 'aac',
        },
        {
            key: 'aba',
            value: 'aba',
        },
        {
            key: 'cba',
            value: 'cba',
        },
        {
            key: 'baa',
            value: 'baa',
        },
    ];
    
    return (
        <div className="demoAll">
            <div className="demo">
                <div className="calendar">
                    <SDcalendar year={2022} month={8} selectDay={selectDay}
                    memo={cMemo} finance={[]}></SDcalendar>
                </div>
                <div className="journey">
                    <SDJourney memo={selectMemo}></SDJourney>
                </div>
            </div>
            <div>
            </div>

            <div className="democ">
                <SDBtn label={'aaa'} click={click}></SDBtn>
                <SDInput label="帳號" change={aaa} placeholder={'請輸入帳號'}></SDInput>
                <SDCheck label="test" type="todo"></SDCheck>
                <SDCheck label="test2" type=""></SDCheck>
                <SDRadio></SDRadio>
                <SDSwitch></SDSwitch>
                <SDRadioGroup data={['aa','bb','cc','dd']}></SDRadioGroup>
            </div>
            
            <div className="democa">
                <div className="demoacc">
                    <SDAccordion topic={topic} content={content}></SDAccordion>
                </div>
                <div className="demoacc">
                    <SDDropdown nowSelect={''} placeholder={'請選擇'} data={testArray}></SDDropdown>
                </div>
            </div>
        </div>
    )    
}

export default Demo;

